import {ImportingDataTypes} from "../../types";
import {createInvalidPartSection, PreventionInvalidityCode} from "./shared";

export const preventativeInteraction = {
    datasourceId: ImportingDataTypes.productCategoryAssignment,
    sections: [
        createInvalidPartSection(),
        {
            sectionKey: 'missingCategoryFields',
            sectionTitle: 'Missing Root Category',
            invalidityCode: PreventionInvalidityCode.MISSING_REQUIRED_FIELDS,
            fields: [
                {
                    key: 'partNumber',
                    label: 'Part Number',
                    type: 'text',
                    extractValue: (o) => typeof o === 'string' ? o : o?.partNo ?? null, // partNo is explicitly used since autocomplete provides partNo field
                    modifyRow: (row, val) => ({...row, partNumber: val})
                },
                {
                    key: 'parentCategoryTitle',
                    label: 'Root Category',
                    type: 'input',
                    extractValue: (o) => typeof o === 'string' ? o : o?.title ?? null,
                    modifyRow: (row, val) => ({...row, parentCategoryTitle: val})
                },
                {
                    key: 'categoryTitle',
                    label: 'Leaf Category',
                    type: 'input',
                    extractValue: (o) => typeof o === 'string' ? o : o?.title ?? null,
                    modifyRow: (row, val) => ({...row, categoryTitle: val})
                }
            ]
        }
    ],
};
